module.exports = __webpack_public_path__ + "static/media/touch.717fd3ef.svg";